import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { title } from 'process'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/login',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/deliver/reportDayOnline',
    component: () => import('@/views/Deliver/ReportDayOnline/ReportDayOnlineList.vue'),
    name: 'ReportDayOnline',
    meta: {
      hidden: true
    }
  },
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   name: 'Redirect',
  //   children: [
  //     {
  //       path: '/redirect/:path(.*)',
  //       name: 'Redirect',
  //       component: () => import('@/views/Redirect/Redirect.vue'),
  //       meta: {}
  //     }
  //   ],
  //   meta: {
  //     hidden: true,
  //     noTagsView: true
  //   }
  // },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  // {
  //   path: '/demo',
  //   component: Layout,
  //   redirect: '/demo/apply',
  //   name: 'Demo',
  //   meta: {
  //     title: '演示',
  //     icon: 'radix-icons:file-text',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'apply',
  //       component: () => import('@/views/Demo/Apply.vue'),
  //       name: 'Apply',
  //       meta: {
  //         title: '申请',
  //         noCache: true,
  //         icon: 'radix-icons:file-text'
  //       }
  //     },
  //     {
  //       path: 'check',
  //       component: () => import('@/views/Demo/Check.vue'),
  //       name: 'Check',
  //       meta: {
  //         title: '审核',
  //         noCache: true,
  //         icon: 'radix-icons:file-text'
  //       }
  //     }
  //   ]
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
